import React, { Component } from "react";
import cx from "../../utils/cx";
import s from "./index.css";

export default class Button extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  setHover(hover) {
    this.setState({ hover });
  }
  render() {
    const { hover } = this.state;
    const {
      className,
      small,
      medium,
      large,
      hoverClassName,
      fontSize,
      children,
      style,
      ...props
    } = this.props;
    return (
      <button
        onMouseEnter={this.setHover.bind(this, true)}
        onMouseLeave={this.setHover.bind(this, false)}
        onTouchStart={this.setHover.bind(this, true)}
        onTouchEnd={this.setHover.bind(this, false)}
        className={cx({
          [s.button]: true,
          [className]: className,
          [hoverClassName]: hoverClassName && hover,
          [s.med]: medium,
          [s.lrg]: large,
          [s.sml]: small
        })}
        style={{ ...style, fontSize }}
        {...props}
      >
        {children}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Buttons/index.js